import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import Axios from "axios";
import { configuration } from "../../appConfig";
import ReportHeader from "./ReportHeader";
import ReportFooter from "./ReportFooter";
import ReportFooter_Swiss from "./ReportFooter_Swiss";
import ReportHeader_Swiss from "./ReportHeader_Swiss";

export class ReportImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScanListRecord: "",
      Hood: [],
      Roof: [],
      RightRoofFrame: [],
      LeftRoofFrame: [],
      TrunkCover: [],
      Trunk: [],
      right: [],
      Left: [],
    };
  }
  async componentDidMount() {
    this.vinFolderList();
    await this.getScanImages();
  }
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );
      if (response.data[0]) {
        this.setState({
          isScanListRecord: response.data[0].isScanListRecord,
        });
      }
    } else {
      this.props.history.push("/login");
    }
  };

  getTotalDents = (part) => {
    let dents = 0;
    this.props.jsonData &&
      this.props.jsonData.length > 0 &&
      this.props.jsonData.forEach((row) => {
        if (row.Part === part) {
          dents = row.TotalDents;
        }
      });
    return dents;
  };

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");

    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;

        const filterImages = (images, keyword) => {
          const filtered = images
            ? images.filter((image) => image.includes(keyword))
            : [];
          return filtered.length > 0 ? filtered[0] : "";
        };

        const getImages = (images, ...keywords) => {
          return keywords.map((keyword) => filterImages(images, keyword));
        };

        const getFilteredImage = (images, keyword) => {
          const filtered = images
            ? images.filter(
                (image) => image.includes(keyword) && image.includes("_1")
              )
            : [];
          return filtered.length > 0 ? filtered[0] : [""];
        };
        const getSuffixImages = (images, keyword) => {
          const filteredNumber = 2
      
            const result = images && images.filter((image, index) => {
              // if (image === "") {
              //   return true; 
              // }
              
              return index >= 0 && index <= filteredNumber;
            });
      
        return result;
          };
        const Left = [
          ...getImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...getImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...getImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...getImages(data.LeftBackFender || data.Left, "LeftBackFender"),
        ].slice(0, 4);

        const right = [
          ...getImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...getImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...getImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...getImages(data.RightBackFender || data.right, "RightBackFender"),
        ].slice(0, 4);

        this.setState({
          Hood: getSuffixImages(data.Hood) || "",
          Roof: getSuffixImages(data.Roof) || "",
          RightRoofFrame: getSuffixImages(data.RightRoofFrame) || "",
          LeftRoofFrame: getSuffixImages(data.LeftRoofFrame) || "",
          TrunkCover: [getFilteredImage(data.TrunkCover, "TrunkCover")],
          Trunk: [getFilteredImage(data.Trunk, "Trunk")],
          right: right,
          Left: Left,
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  lang = (word) => {
    const { lang, words } = this.props;
    return words[word] ? words[word][lang] : word;
  };

  render() {
    const client = localStorage.getItem("client");
    const { isDentShowingReport } = this.props;

    return (
      <>
        {this.state.isScanListRecord === "0" && (
          <>
            {/* Hood-partsimages */}
            <div
              className="row row-zero page-break-row report-full-wrapper"
              data-content-name={this.lang("Page")}
            >
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container">
                        <div className="row title-row-main">
                          <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                              {this.lang("Hood report")}{" "}
                            </h3>
                          </div>
                        </div>
                        <div className="all_hood_images">
                          {this.state.Hood &&
                            this.state.Hood.length > 0 &&
                            this.state.Hood.map((r, i) => {
                              return (
                                isDentShowingReport == 1 &&
                                r != "" && (
                                  <div
                                    key={`dent-${i}`}
                                    className="dent_report_position"
                                  >
                                    <div className="row left-side-row">
                                      <div className="col text-center">
                                        <div className="col-bg">
                                          <p>
                                            {this.lang("Dents")}
                                            <span>
                                              : {this.getTotalDents("Hood")}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              );
                            })}
                          {this.state.Hood &&
                            this.state.Hood.length > 0 &&
                            this.state.Hood.map((r, i) => {
                              return (
                                <>
                                  <div className="row left-side-row">
                                    <div className="col-sm-12 col-zero all-images-wrapper">
                                      {r == "" ? (
                                        <img
                                          alt=""
                                          className="default-image-wrapper"
                                          src={require("../../assets/img/brand/default-image.png")}
                                          zoom="20"
                                        />
                                      ) : (
                                        <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss reportType="newReportFull" />
                </Card>
              </div>
            </div>

            {/* Roof-partsimages */}
            <div
              className="row row-zero page-break-row report-full-wrapper"
              data-content-name={this.lang("Page")}
            >
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container">
                        <div className="row title-row-main">
                          <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                              {this.lang("Roof report")}
                            </h3>
                          </div>
                        </div>
                        <div className="all_roof_images">
                          <div className="row left-side-row">
                            <div className="col-3 col-zero">
                              <div className="row all-images-wrapper row-zero">
                                <div className="col-sm-12 col-zero">
                                  {this.state.LeftRoofFrame &&
                                    this.state.LeftRoofFrame.length > 0 &&
                                    this.state.LeftRoofFrame.map((r, i) => {
                                      return (
                                        isDentShowingReport == 1 &&
                                        r != "" && (
                                          <div
                                            key={`dent-${i}`}
                                            className="dent_report_position"
                                          >
                                            <div className="row left-side-row">
                                              <div className="col text-center">
                                                <div className="col-bg">
                                                  <p>
                                                    {this.lang("Dents")}
                                                    <span>
                                                      :{" "}
                                                      {this.getTotalDents(
                                                        "LeftRoofFrame"
                                                      )}
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      );
                                    })}
                                  {this.state.LeftRoofFrame &&
                                    this.state.LeftRoofFrame.length > 0 &&
                                    this.state.LeftRoofFrame.map((r, i) => {
                                      return (
                                        <>
                                          <div className="">
                                            {r == "" ? (
                                              <img
                                                alt=""
                                                className="default-image-wrapper"
                                                src={require("../../assets/img/brand/default-image.png")}
                                                zoom="20"
                                              />
                                            ) : (
                                              <img
                                                alt=""
                                                className="pl-0"
                                                src={`${r}?t=${new Date().getTime()}`}
                                                zoom="20"
                                              />
                                            )}
                                          </div>
                                        </>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-zero">
                              <div className="row all-images-wrapper row-zero pl-1 pr-1">
                                <div className="col-sm-12 col-zero">
                                  {this.state.Roof &&
                                    this.state.Roof.length > 0 &&
                                    this.state.Roof.map((r, i) => {
                                      return (
                                        isDentShowingReport == 1 &&
                                        r != "" && (
                                          <div
                                            key={`dent-${i}`}
                                            className="dent_report_position"
                                          >
                                            <div className="row left-side-row">
                                              <div className="col text-center">
                                                <div className="col-bg">
                                                  <p>
                                                    {this.lang("Dents")}
                                                    <span>
                                                      :{" "}
                                                      {this.getTotalDents(
                                                        "Roof"
                                                      )}
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      );
                                    })}
                                  {this.state.Roof &&
                                    this.state.Roof.length > 0 &&
                                    this.state.Roof.map((r, i) => {
                                      return r == "" ? (
                                        <img
                                          alt=""
                                          className="default-image-wrapper"
                                          src={require("../../assets/img/brand/default-image.png")}
                                          zoom="20"
                                        />
                                      ) : (
                                        <img
                                          alt=""
                                          className="pl-0 pr-0"
                                          src={`${r}?t=${new Date().getTime()}`}
                                          zoom="20"
                                        />
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div className="col-3 col-zero">
                              <div className="row all-images-wrapper row-zero">
                                <div className="col-sm-12 col-zero">
                                  {this.state.RightRoofFrame &&
                                    this.state.RightRoofFrame.length > 0 &&
                                    this.state.RightRoofFrame.map((r, i) => {
                                      return (
                                        isDentShowingReport == 1 &&
                                        r != "" && (
                                          <div
                                            key={`dent-${i}`}
                                            className="dent_report_position"
                                          >
                                            <div className="row left-side-row">
                                              <div className="col text-center">
                                                <div className="col-bg">
                                                  <p>
                                                    {this.lang("Dents")}
                                                    <span>
                                                      :{" "}
                                                      {this.getTotalDents(
                                                        "RightRoofFrame"
                                                      )}
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      );
                                    })}
                                  {this.state.RightRoofFrame &&
                                    this.state.RightRoofFrame.length > 0 &&
                                    this.state.RightRoofFrame.map((r, i) => {
                                      return (
                                        <div key={`image-${i}`} className="">
                                          {r === "" ? (
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          ) : (
                                            <img
                                              alt=""
                                              className="pl-0"
                                              src={`${r}?t=${new Date().getTime()}`}
                                              zoom="20"
                                            />
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss reportType="newReportFull" />
                </Card>
              </div>
            </div>

            {/* LFF-LFD-LBD-LBF-RFF-RFD-RBD-RBF-partsimages */}

            <div
              className="row row-zero page-break-row report-full-wrapper"
              data-content-name={this.lang("Page")}
            >
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container">
                        <div className="row left-side-row">
                          <div className="col-lg-6 col-md-6 left-row-img-wrapper rotate-90-deg">
                            <div className="row title-row-main">
                              <div className="col-12">
                                <h3 className="report-title">
                                  {this.lang("Left")}
                                </h3>
                              </div>
                            </div>
                            <div>
                              {this.state.Left &&
                                this.state.Left.length > 0 &&
                                this.state.Left.map((r, i) => {
                                  const partName = r
                                    .split("/")
                                    [r.split("/").length - 1].split(".")[0]
                                    .split("_")[1];
                                  return (
                                    <div className="row left-side-row">
                                      {isDentShowingReport == 1 && r != "" && (
                                        <div className="dent_report_position">
                                          <div className="row left-side-row">
                                            <div className="col text-center">
                                              <div className="col-bg">
                                                <p>
                                                  {this.lang("Dents")}
                                                  <span>
                                                    :{" "}
                                                    {this.getTotalDents(
                                                      partName
                                                    )}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="col-sm-12 rotate-col">
                                        {r == "" ? (
                                          <img
                                            alt=""
                                            className="default-image-wrapper"
                                            src={require("../../assets/img/brand/default-image.png")}
                                            zoom="20"
                                          />
                                        ) : (
                                          <img
                                            alt=""
                                            className=""
                                            src={`${r}?t=${new Date().getTime()}`}
                                            zoom="20"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 left-row-img-wrapper rotate-270-deg">
                            <div className="row title-row-main">
                              <div className="col-12">
                                <h3 className="report-title">
                                  {this.lang("Right")}
                                </h3>
                              </div>
                            </div>
                            <div>
                              {this.state.right &&
                                this.state.right.length > 0 &&
                                this.state.right.map((r, i) => {
                                  const partName = r
                                    .split("/")
                                    [r.split("/").length - 1].split(".")[0]
                                    .split("_")[1];
                                  return (
                                    <div className="row left-side-row">
                                      {isDentShowingReport == 1 && r != "" && (
                                        <div className="dent_report_position">
                                          <div className="row left-side-row">
                                            <div className="col text-center">
                                              <div className="col-bg">
                                                <p>
                                                  {this.lang("Dents")}
                                                  <span>
                                                    :{" "}
                                                    {this.getTotalDents(
                                                      partName
                                                    )}
                                                  </span>
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="col-sm-12 rotate-col">
                                        {r == "" ? (
                                          <img
                                            alt=""
                                            className="default-image-wrapper"
                                            src={require("../../assets/img/brand/default-image.png")}
                                            zoom="20"
                                          />
                                        ) : (
                                          <img
                                            alt=" "
                                            className=""
                                            src={`${r}?t=${new Date().getTime()}`}
                                            zoom="20"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <div className="center-dotted-image-left-right"></div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss reportType="newReportFull" />
                </Card>
              </div>
            </div>

            {/* Trunk & TrunkCover - partsimages */}

            <div
              className="row row-zero page-break-row report-full-wrapper"
              data-content-name={this.lang("Page")}
            >
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="p-0">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container trunk_images_wrapper">
                        <div className="row left-side-row">
                          <div className="col-sm-12 col-zero">
                            <h3 className="report-title">
                              {this.lang("Trunk report")}
                            </h3>
                          </div>
                        </div>
                        {this.state.TrunkCover &&
                          this.state.TrunkCover.length > 0 &&
                          this.state.TrunkCover.map((r, i) => {
                            return (
                              <div className="row trunk_row_wrapper row-zero">
                                <div className="col-lg-7 col-md-7 col-sm-12">
                                  {isDentShowingReport == 1 && r != "" && (
                                    <div className="dent_report_position">
                                      <div className="row left-side-row">
                                        <div className="col text-center">
                                          <div className="col-bg">
                                            <p>
                                              {this.lang("Dents")}
                                              <span>
                                                : {this.getTotalDents("Trunk")}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row trunk-bottom-row">
                                    <div className="col-12 trunk-img-col">
                                      {r == "" ? (
                                        <img
                                          alt=""
                                          className="default-image-wrapper"
                                          src={require("../../assets/img/brand/default-image.png")}
                                          zoom="20"
                                        />
                                      ) : (
                                        <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        {this.state.Trunk &&
                          this.state.Trunk.length > 0 &&
                          this.state.Trunk.map((r, i) => {
                            const report1Image = r.includes("_1");
                            return (
                              <div className="row trunk_row_wrapper row-zero">
                                <div className="col-lg-7 col-md-7 col-sm-12">
                                  {isDentShowingReport == 1 && r != "" && (
                                    <div className="dent_report_position">
                                      <div className="row left-side-row">
                                        <div className="col text-center">
                                          <div className="col-bg">
                                            <p>
                                              {this.lang("Dents")}
                                              <span>
                                                : {this.getTotalDents("Trunk")}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row trunk-bottom-row">
                                    <div className="col-12 trunk-img-col">
                                      {r == "" ? (
                                        <img
                                          alt=""
                                          className="default-image-wrapper"
                                          src={require("../../assets/img/brand/default-image.png")}
                                          zoom="20"
                                        />
                                      ) : (
                                        <img
                                          alt=""
                                          className=""
                                          src={`${r}?t=${new Date().getTime()}`}
                                          zoom="20"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss reportType="newReportFull" />
                </Card>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default ReportImages;
